/**
 * @module app.sources
 */
import olSourceWMTS from 'ol/source/WMTS.js';
import olTilegridWMTS from 'ol/tilegrid/WMTS.js';
import {proj as proj21781} from '@geoblocks/proj/src/EPSG_21781.js';


/**
 * @const
 * @type {!Array.<number>}
 */
export const RESOLUTIONS = [
  4000, 3750, 3500, 3250, 3000, 2750, 2500, 2250, 2000, 1750, 1500, 1250,
  1000, 750, 650, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1.5, 1, 0.5
];


/**
 * @const
 * @type {!Array.<string>}
 */
export const MATRIX_IDS = RESOLUTIONS.map(function(value, index) {
  return String(index);
});


/**
 * @const
 * @type {ol.Coordinate}
 */
export const ORIGIN = [420000, 350000];


/**
 * @const
 * @type {ol.Extent}
 */
export const EXTENT = proj21781.getExtent();


/**
 * @const
 * @type {ol.tilegrid.WMTS}
 */
export const WMTS_TILE_GRID = new olTilegridWMTS({
  origin: ORIGIN,
  extent: EXTENT,
  resolutions: RESOLUTIONS,
  matrixIds: MATRIX_IDS
});

const initialSearchParams = new URLSearchParams(document.location.search);


/**
 * @param {string} urls
 * @param {string} layer
 * @param {string} timestamp
 * @param {string} format
 * @param {function(ol.Tile, string): undefined} [tileLoadFunction]
 * @return {!ol.source.WMTS}
 */
export const swisstopo = (urls, layer, timestamp, format, tileLoadFunction) => {
  // Use 21781 tile coordinates to request 2056 tiles.
  // This is possible because the 21781 and 2056 TileMatrixSets are equivalent, meaning that
  // they have the same resolutions and equivalent bounds (2m E / 1m N offset).
  // Note that the order of TileCol/TileRow is different between the two.
  // See https://api3.geo.admin.ch/services/sdiservices.html#gettile
  const tileCoordinateUrl = '2056/{TileMatrix}/{TileCol}/{TileRow}';
  let tilePixelRatio = 1;
  let zDirection = 0;

  if (devicePixelRatio > 1) {
    const p = initialSearchParams;
    tilePixelRatio = p.has('tilePixelRatio') ? parseInt(p.get('tilePixelRatio')) : 2;
    zDirection = p.has('zDirection') ? parseInt(p.get('zDirection')) : -1;
  }

  const source = new olSourceWMTS({
    url: `${urls}1.0.0/${layer}/default/{Time}/${tileCoordinateUrl}.${format}`,
    layer: layer,
    projection: proj21781,
    style: 'default',
    matrixSet: '21781',
    requestEncoding: 'REST',
    dimensions: {
      'Time': timestamp
    },
    tileLoadFunction,
    tileGrid: WMTS_TILE_GRID,
    transition: 0,
    zDirection: zDirection,
    tilePixelRatio: tilePixelRatio,
  });
  return source;
};


/**
 * @param {string} urls
 * @param {string} layer
 * @param {string} timestamp
 * @return {!ol.source.WMTS}
 */
export const schweizmobil = (urls, layer, timestamp) => {
  const source = new olSourceWMTS({
    url: urls + '1.0.0/{Layer}/default/{Time}' +
        '/swissgrid/{TileMatrix}/{TileRow}/{TileCol}.png',
    projection: proj21781,
    layer: layer,
    style: 'default',
    matrixSet: 'swissgrid',
    requestEncoding: 'REST',
    dimensions: {
      'Time': timestamp
    },
    tileGrid: WMTS_TILE_GRID,
    crossOrigin: 'anonymous',
    transition: 0,
  });
  return source;
};
